import React from 'react';
import { Box, Card, Text } from '@wix/design-system';
import { StatusCompleteFilledSmall } from '@wix/wix-ui-icons-common';

import { PluginLogo } from './pluginLogo';
import { useWidgetPluginManager } from '../hooks';
import { useTranslation } from '../../useTranslation';
import { WidgetPlugin } from '../../../types/widgetPlugins';

import s from './pluginsPanel.module.scss';

export const PluginInfo = (props: { plugin: WidgetPlugin }) => {
  const { plugin } = props;
  const { isPluginInstalled } = useWidgetPluginManager();
  const [t] = useTranslation();

  const { id, name, description, author, price } = plugin;

  return (
    <Card className={s.pluginCard}>
      <Box
        padding="SP3"
        direction="vertical"
        height="198px"
        dataHook={`widgetPlugins.pluginId:${id}`}
        className={s.pluginDetails}
      >
        <Box marginBottom="SP2">
          <PluginLogo plugin={plugin} width={35} height={35} />
        </Box>

        <Box direction="vertical" marginBottom="SP1">
          <Box marginBottom="2px">
            <Text weight="bold" size="small" ellipsis maxLines={2}>
              {name}
            </Text>
          </Box>

          <Box>
            <Text size="tiny" maxLines={1} ellipsis>
              {t('PLATFORM_Widget_Slots_plugin_developer', {
                company_name: author,
              })}
            </Text>
          </Box>
        </Box>

        <Box paddingBottom="SP1">
          <Text size="tiny" ellipsis maxLines={2}>
            {description}
          </Text>
        </Box>

        <Box flexGrow={1} />

        {isPluginInstalled(plugin) && (
          <Box>
            <Text
              size="tiny"
              skin="success"
              className={s.pluginInstalled}
              dataHook="widgetPlugins.isInstalled"
            >
              <StatusCompleteFilledSmall className={s.pluginInstalledIcon} />
              {t('PLATFORM_Widget_Slots_Modal_Installed')}
            </Text>
          </Box>
        )}
      </Box>
    </Card>
  );
};
